import React from 'react';
import { cn, cx } from '@/utils';

import { COLORS } from '@/utils/constants';
import InfoBar from '@/components/common/Icons/InfoBar';
import InputError from '@/components/common/Messages/InputError';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/common/newTooltip';

import styles from './styles.module.css';

export type Props = {
  multiple?: boolean;
  disabled?: boolean;
  options?: any;
  loading?: boolean;
  title?: string;
  actualLength?: number;
  showLength?: boolean;
  placeholder?: string;
  className?: string;
  textColor?: string;
  infoBoolean?: boolean;
  currentValue?: any;
  type?: React.HTMLInputTypeAttribute | undefined;
  inputProps?: React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  >;
  maxLength?: number;
  fieldError?: string | undefined;
  infoText?: React.ReactNode;
  showError?: boolean;
};
const InputWithTitle = ({
  actualLength,
  title,
  maxLength,
  placeholder,
  currentValue,
  showLength,
  className,
  textColor = COLORS.tundora,
  type = 'text',
  inputProps,
  fieldError,
  infoBoolean,
  infoText,
  disabled,
  showError = true,
}: Props) => {
  return (
    <>
      <div className={className}>
        <label className="body-text1" style={{ color: textColor }}>
          {title}
        </label>
        <br />
        <div className="flex items-center">
          <input
            {...(currentValue !== undefined ? { value: currentValue } : {})}
            className={cx(
              'body-text1 mt-[8px] w-full text-tundora outline-none focus:border-primary',
              styles.input,
              disabled ? 'bg-gray-100 hover:border-gray-500' : ''
            )}
            placeholder={placeholder}
            type={type}
            maxLength={maxLength}
            autoComplete="off"
            disabled={disabled}
            min={inputProps?.min}
            {...inputProps}
          />

          {infoBoolean && (
            <div className="ml-3 flex items-center justify-center">
              <Tooltip disableHoverableContent={false}>
                <TooltipTrigger asChild>
                  <button type="button" className="cursor-pointer" aria-label="Ayuda">
                    <InfoBar />
                  </button>
                </TooltipTrigger>
                <TooltipContent
                  side="top"
                  className="z-50 max-h-[360px] max-w-[520px] overflow-y-auto whitespace-pre-wrap border border-[rgba(0,0,0,0.1)] bg-white p-3 font-workSans text-black shadow-[0_8px_24px_rgba(0,0,0,0.16)]"
                  style={{ lineHeight: '1.3' }}
                >
                  {infoText}
                </TooltipContent>
              </Tooltip>
            </div>
          )}
        </div>
        <div className={cn('relative', { hidden: Boolean(fieldError) })}>
          <div className="relative flex items-end justify-end bg-red-600">
            {showLength && (
              <label className="body-text1 absolute bottom-[-22px] text-right !text-[14px] text-dimGray">
                {actualLength}/{maxLength}
              </label>
            )}
          </div>
        </div>
        {showError && <InputError message={fieldError} />}
      </div>
    </>
  );
};
export default InputWithTitle;
